module.exports = "### Common\n\nWe use these common tokens when necessary.\n"